import { propertyResponseRequiresEdit } from "@/common/property";
import propertyService from "@/services/property.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "preparedAddress",
      "httpConfigAsRqs",
      "getQuoteRequestId",
    ]),
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "setPropertyData",
      "setPropertyDataAndSources",
      "setPropertyDetailsFormVisibility",
      "setIsLNErrorMessageEnabled",
    ]),
    propertyDetailsLookup() {
      this.loading = true;
      const request = this.preparedAddress;
      request["QuoteRequestId"] = this.getQuoteRequestId;
      this.setPropertyData(null);

      return propertyService
        .propertyLookup(request, this.httpConfigAsRqs)
        .then((response) => {
          // response successful

          this.setPropertyData(response);
          this.setPropertyDetailsFormVisibility(false);
          this.loading = false;
          if (propertyResponseRequiresEdit(response)) {
            this.setPropertyDetailsFormVisibility(true);
            this.setIsLNErrorMessageEnabled(true);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.setPropertyDetailsFormVisibility(true);
          this.setIsLNErrorMessageEnabled(true);
          if (error.response && error.response.data) {
            // response failed
            this.setPropertyData(error.response.data);
          }
        });
    },

    propertyDetailsLookupRemoveDependenciesByQuestion() {
      this.loading = true;
      const request = this.preparedAddress;
      request["QuoteRequestId"] = this.getQuoteRequestId;
      this.setPropertyDataAndSources(null);

      return propertyService
        .propertyLookup(request, this.httpConfigAsRqs)
        .then((response) => {
          // response successful

          this.setPropertyDataAndSources(response);
          this.setPropertyDetailsFormVisibility(false);
          this.loading = false;
          if (propertyResponseRequiresEdit(response)) {
            this.setPropertyDetailsFormVisibility(true);
            this.setIsLNErrorMessageEnabled(true);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.setPropertyDetailsFormVisibility(true);
          this.setIsLNErrorMessageEnabled(true);
          if (error.response && error.response.data) {
            // response failed
            this.setPropertyDataAndSources(error.response.data);
          }
        });
    },
  },
};
